<template>
	<v-layout wrap class="section-information">
		<v-flex xs12 mb-3 class="center">
			<img src="/static/images/banners/error.svg" alt="error" height="89">
		</v-flex>
		<v-flex xs12>
			<p class="text-message">{{ message }}</p>
		</v-flex>
		<v-flex xs12>
			<p class="text-message-down mb-5">{{ messageDown}} </p>
		</v-flex>
		<v-flex xs12 class="center" v-if="invalid">
			<p class="btn-link">mibodega@makipos.la</p>
		</v-flex>
		<v-flex xs12 v-else>
			<v-layout justify-center>
				<v-flex
					v-for="(contact, index) in contacts"
					:key="index" xs4 class="center"
				>
					<a :href="wspContact(contact)" class="btn-link" target="_blank">
						<img src="/static/images/banners/whatsapp-green.svg" alt="whatsapp">
						<span>{{ contact.name }}</span>
					</a>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>
<script>
function created() {
	const saleAdvisers = process.env.SALE_ADVISERS.split(', ').map((sa) => {
		const saItems = sa.split('-');
		return {
			name: saItems[0],
			phone: `+${saItems[1]}`,
		};
	});
	this.contacts = [...saleAdvisers];
}

function wspContact({ phone }) {
	if (this.wspLink) {
		return `https://api.whatsapp.com/send?phone=${phone}`;
	}
	return `https://web.whatsapp.com/send?phone=${phone}`;
}

function wspLink() {
	const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
	return reg.test(navigator.userAgent);
}

function data() {
	return {
		contacts: [],
	};
}

export default {
	name: 'section-information',
	computed: {
		wspLink,
	},
	created,
	data,
	methods: {
		wspContact,
	},
	props: {
		message: String,
		messageDown: String,
		invalid: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style lang="scss" scoped>
	.text-message {
		color: color(error-text);
		font-size: size(large37);
		font-weight: 600;
		margin-bottom: 80px;
		text-align: center;
	}

	.center {
		text-align: center;
	}

	.btn-link {
		background: color(green-link);
		border-radius: 7px;
		color: color(title-green);
		display: inline-block;
		font-size: size(medium23);
		font-weight: 600;
		padding: 10px 20px;
		text-decoration: none;
	}

	.section-information {
		padding: 100px 0;
	}

	.text-message-down {
		color: color(info-text);
		font-size: size(large28);
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/section-information.vue